export default {"src":"/_next/static/media/alcohol.3414e142.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};